export default __webpack_public_path__ + "static/media/tour.e052ff70.mp4";